






















import { Component, Vue, Prop, Emit, Ref } from 'vue-property-decorator'

@Component

export default class ComponentUploadDocumentoMultiplasNotas extends Vue {
  $refs!: { upload: any }
  @Prop({ required: true }) inputId: string
  @Prop({ required: true, default: true }) showForm: boolean
  @Prop({ required: false }) accept: string
  @Prop({ default: 'Carregar' }) title: string
  @Prop({ default: true }) showIcon: boolean
  model: any[] = []

  @Emit('inputFile')
  inputFile(file) { }
}
